import {useTranslation, Trans} from "react-i18next";
import Dropzone from "react-dropzone";
import {useEffect, useState} from "react";
import {getErrorMessageHtml} from "../../Utils/FormHelpers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileUpload} from "@fortawesome/free-solid-svg-icons";
import {Controller} from "react-hook-form";

export const FileUpload = (props) => {
    const {
        register,
        name,
        translationIndex,
        errors,
        multiple = false,
        currentValue = null,
        control
    } = props;
    const {t} = useTranslation();

    const [thumbs, setThumbs] = useState([]);

    useEffect(() => {
        if(!Array.isArray(currentValue)){
            setThumbs([currentValue]);
        }
    }, [currentValue]);

    const renderPreview = (files) => {
        return files.map((file, index) => {
            const isImage = file.type.startsWith('image/');
            const fileUrl = URL.createObjectURL(file);

            return (
                <div key={index} style={{ margin: '10px', textAlign: 'center' }}>
                    {isImage ? (
                        <img
                            src={fileUrl}
                            alt={file.name}
                            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                        />
                    ) : (
                        <p>{file.name}</p>
                    )}
                </div>
            );
        });
    };

    return (
        <div>
            <label htmlFor={name}
                   className="block text-left text-sm font-medium leading-6 text-gray-900 mb-2">
                {t(`${translationIndex}`)} <span className="text-xs text-gray-400"></span>
            </label>
            <Controller
                control={control}
                defaultValue={[]}
                name={name}
                register={register}
                render={({ field: { onChange, onBlur, value } }) => (
                    <Dropzone 
                        onDrop={(acceptedFiles) => onChange(acceptedFiles)} 
                        accept={{
                            'application/pdf': ['.pdf'],
                            'image/*': []
                        }}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps({ className: 'dropzone cursor-pointer' })}>
                                <input {...getInputProps()} />
                               <p className="py-8 border-dotted mx-auto border-2 text-center">
                                    <Trans i18nKey="file_upload.drop_hint" components={{1: <span className="text-primary cursor-pointer" />}} />
                                </p>
                                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                    {value && renderPreview(value)}
                                </div>
                            </div>
                        )}
                    </Dropzone>
                )}
            />


            {getErrorMessageHtml(errors, name)}
        </div>
    )
}
